/*
 * Cart icon bounce — fires a one-shot bounce on #cart-icon-bubble only when the
 * cart item count INCREASES (an add). No bounce on page load or on removal.
 *
 * Detection notes (verified against the Cart AJAX API):
 *   - source 'cart-items'  -> cartData is the full /cart/change.js cart (has item_count);
 *                             a quantity change can be + or -, so compare counts.
 *   - source 'quick-add'   -> cartData is the full cart (has item_count).
 *   - source 'product-form'-> cartData is the /cart/add.js response, which has NO
 *                             item_count and is always an add -> treat as an add by source.
 */
(function () {
  const icon = document.getElementById('cart-icon-bubble');
  if (!icon) return;

  const readBadgeCount = () => {
    const badge = icon.querySelector('.cart-count-bubble span[aria-hidden]');
    if (!badge) return 0;
    const value = parseInt(badge.textContent.trim(), 10);
    return Number.isNaN(value) ? 0 : value;
  };

  // Seed from the rendered badge so the first add doesn't depend on a prior event.
  let previousCount = readBadgeCount();

  const triggerBounce = () => {
    // Restart cleanly if a previous bounce is still running.
    icon.classList.remove('cart-bounce');
    // Force reflow so re-adding the class restarts the animation.
    void icon.offsetWidth;
    icon.classList.add('cart-bounce');
  };

  // Remove the class on each cycle's end so the bounce can re-fire on the next add.
  icon.addEventListener('animationend', (event) => {
    if (event.animationName === 'cart-bounce') icon.classList.remove('cart-bounce');
  });

  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    const newCount = event && event.cartData ? event.cartData.item_count : undefined;

    if (typeof newCount === 'number') {
      if (newCount > previousCount) triggerBounce();
      previousCount = newCount;
      return;
    }

    // No item_count in the payload -> /cart/add.js response (product-form) = an add.
    if (event && event.source === 'product-form') {
      triggerBounce();
      // Resync from the freshly re-rendered badge so a later in-cart decrement
      // isn't misread as an increase.
      requestAnimationFrame(() => {
        previousCount = readBadgeCount();
      });
    }
  });
})();
